//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { loadDistributionRegions } from '@/utils/distributionRegionLoader';
export default {
  name: 'DistributionRegionFilter',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      regions: {
        options: [],
        paths: {},
        prefixes: {}
      },
      failed: false
    };
  },
  computed: {
    selectedPath: function selectedPath() {
      return this.regions.paths[String(this.value)] || [];
    }
  },
  created: function created() {
    this.load();
  },
  methods: {
    load: function load() {
      var _this = this;
      loadDistributionRegions().then(function (data) {
        _this.regions = data;
        _this.failed = false;
      }).catch(function () {
        _this.failed = true;
      });
    },
    onVisible: function onVisible(visible) {
      if (visible && this.failed) this.load();
    },
    change: function change(path) {
      var code = path && path.length ? path[path.length - 1] : '';
      this.$emit('input', this.regions.prefixes[code] || code);
    }
  }
};